import { render, staticRenderFns } from "./Paragraph.vue?vue&type=template&id=adc94bac"
import script from "./Paragraph.vue?vue&type=script&setup=true&lang=js"
export * from "./Paragraph.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports